import { ExclamationCircleFilled } from '@ant-design/icons'
import useNotification from 'antd/lib/notification/useNotification'
import { ReactNode, useCallback, useMemo } from 'react'
import { createGlobalStyle } from 'styled-components'

const NOTIFICATION_CLASS_PREFIX = 'video-downloader-notification'

const GlobalStyle = createGlobalStyle`
  .${NOTIFICATION_CLASS_PREFIX}-notice-wrapper > .${NOTIFICATION_CLASS_PREFIX}-notice.${NOTIFICATION_CLASS_PREFIX}-notice-closable {
    width: 760px;
    background-color: #E67F3A;
    border-radius: 5px;
    
    .${NOTIFICATION_CLASS_PREFIX}-notice-message, 
    .${NOTIFICATION_CLASS_PREFIX}-notice-close-icon {
      color: #ffffff;
      font-size: 16px;
      line-height: 22.4px;
      letter-spacing: -2.5%;
      font-weight: 700;
      text-align: center;
    }
  }
`

export const useToolsNotification = () => {
  const [api, contextHolder] = useNotification({
    maxCount: 1,
    duration: 5,
    top: 60,
    placement: 'top',
    stack: false,
    prefixCls: NOTIFICATION_CLASS_PREFIX,
  })

  const open = useCallback(
    (message?: ReactNode) => {
      api.open({
        message: (
          <span>
            <ExclamationCircleFilled css={{ color: '#ffffff' }} />
            &nbsp;&nbsp;&nbsp;&nbsp;
            {message}
          </span>
        ),
      })
    },
    [api],
  )

  const memoizedContextHolder = useMemo(
    () => (
      <>
        <GlobalStyle />
        {contextHolder}
      </>
    ),
    [contextHolder],
  )

  return {
    open,
    contextHolder: memoizedContextHolder,
  }
}
